import React from 'react';

const LoginHeader = ({ title = "Welcome Back", subtitle = "Sign in to your ServiceReviewAI account to manage your reviews and grow your business" }) => {
  return (
    <div className="text-center mb-8">
      {/* ServiceReviewAI Logo */}
      <div className="flex justify-center mb-6">
        <img 
          src="/assets/images/servicereviewai-logo.svg" 
          alt="ServiceReviewAI"
          className="h-8 w-auto"
        />
      </div>

      {/* Welcome Text */}
      <div className="space-y-2">
        <h1 className="text-2xl font-bold text-text-primary">
          {title}
        </h1>
        <p className="text-text-secondary">
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;